export const config = {
  AI_DATASTORE_RESOURCE_BUCKET: {
    local: 'ai-datastore-resource-dev',
    development: 'ai-datastore-resource-dev',
    pre: 'bty-gemini-resource-pre',
    production: 'ty-gemini-resource-prod',
  },
}
